const updates = [
  { date: '2024.07.28', title: '《咒术回战》最终章震撼更新', desc: '涩谷事变终局之战正式开启，五条悟与宿傩的巅峰对决引爆全网讨论。', tag: '日漫', icon: 'ri-fire-line', color: 'primary' },
  { date: '2024.07.27', title: '韩漫《我独自升级》番外篇上线', desc: '人气韩漫番外特别篇独家上线酷漫屋，揭开主角觉醒背后的隐藏故事。', tag: '韩漫', icon: 'ri-star-line', color: 'accent' },
  { date: '2024.07.26', title: '国漫《镖人》最新话热血来袭', desc: '刀马一行人的西域冒险进入白热化阶段，国漫之光持续高能输出。', tag: '国漫', icon: 'ri-sword-line', color: 'secondary' },
  { date: '2024.07.25', title: '《间谍过家家》剧场版联动漫画发布', desc: '配合剧场版上映，原作漫画推出特别联动篇章，安妮亚的可爱度再次爆表。', tag: '日漫', icon: 'ri-heart-line', color: 'primary' },
  { date: '2024.07.24', title: '酷漫屋新增1000+部经典漫画资源', desc: '平台漫画库再次升级，大量经典老番和绝版漫画重新上线，怀旧党不容错过。', tag: '平台', icon: 'ri-book-open-line', color: 'accent' },
  { date: '2024.07.23', title: '韩漫《全知读者视角》第二季确定', desc: '备受期待的韩漫神作宣布第二季制作决定，酷漫屋已确认同步连载。', tag: '韩漫', icon: 'ri-eye-line', color: 'secondary' },
  { date: '2024.07.22', title: '下拉式滚动阅读功能全面优化', desc: '酷漫屋技术团队对滚动阅读引擎进行全面升级，加载速度提升40%，阅读体验更加流畅。', tag: '功能', icon: 'ri-speed-up-line', color: 'primary' },
  { date: '2024.07.21', title: '漫画社区热门讨论：七月新番测评', desc: '读者社区七月新番测评活动火热进行中，参与讨论赢取漫画周边好礼。', tag: '社区', icon: 'ri-chat-3-line', color: 'accent' },
];

const colorMap: Record<string, { bg: string; text: string; line: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', line: 'border-primary-300' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', line: 'border-secondary-300' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', line: 'border-accent-300' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          漫画世界每日新鲜事，追更快讯一站掌握
        </p>
        <div className="relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-200"></div>
          <div className="space-y-5">
            {updates.map((item) => {
              const c = colorMap[item.color];
              return (
                <div key={item.title} className="relative flex gap-4 md:gap-6 pl-10 md:pl-14">
                  <div className={`absolute left-[14px] md:left-[22px] w-3 h-3 rounded-full border-2 ${c.line} bg-background-50 z-10`}></div>
                  <div className="flex-1 bg-background-50 rounded-xl border border-background-200/80 p-4 md:p-5 hover:border-primary-200/60 transition-colors cursor-pointer">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md ${c.bg} ${c.text} text-xs font-medium whitespace-nowrap`}>
                        <i className={`${item.icon} text-[10px]`}></i>{item.tag}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1">{item.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}